var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-success",class:{'badge-success': _vm.is_gdpr, 'badge-warning': !_vm.is_gdpr}},[(_vm.is_gdpr)?_c('span',[_vm._v("GDPR"),_c('i',{staticClass:"ion-checkmark ml-2"})]):_c('span',[_vm._v("Not GDPR compliant")])])
}
var staticRenderFns = []

export { render, staticRenderFns }